import { useLocale } from '../i18n/LocaleProvider'
import { useState } from 'react'
import { CaretDown } from '@phosphor-icons/react'
import './FAQSection.css'

const faqs = [
  { q: 'Do I need a Japanese legal entity?', a: 'It depends on your scale and strategy. For one-off cross-border SaaS sales or channel partnerships, you may not need a local entity. For sustained enterprise sales, hiring, or B2B contracts with Japanese buyers who require a domestic counterparty, a Japanese entity is typically expected.\n\nOur Starter Pack includes full 合同会社 (GK) setup — the LLC-equivalent structure used by Apple Japan, Google Japan, and most foreign tech companies entering Japan.' },
  { q: 'How long does the Starter Pack take?', a: '6–8 weeks for core deliverables (JP landing page, portfolio, document translation, and 2 months of social media setup and management).' },
  { q: 'What happens after the Starter Pack?', a: 'Most clients transition to the Retainer Plan at $2,500/month for ongoing SNS management and Japanese-language customer success support.' },
  { q: 'How do you handle quality control?', a: 'Each client is assigned a dedicated Delivery Manager who serves as your single point of accountability throughout the engagement. Your Delivery Manager personally conducts the final quality assurance review on all deliverables and oversees any revisions required to meet the agreed standard. The scope and frequency of revisions are governed by the terms set forth in our Master Service Agreement, ensuring clear expectations on both sides. In addition, we report bi-monthly KPIs so you always have visibility into what\'s working.' },
  { q: 'What industries do you serve?', a: 'Our primary focus is overseas SaaS and AI/GenAI startups entering the Japanese market. We also support D2C brands and companies in creative industries as a secondary practice area. We do not currently serve the pharmaceutical or financial services sectors.' },
  { q: 'Your company seems young and small. Why should I trust you?', a: 'You\'re right. We are a young firm, and we don\'t try to hide that. We\'re in this business because we genuinely believe in it and love the work, and that shows up in how we deliver. Trust isn\'t claimed; it\'s earned, so we build our reputation brick by brick through disciplined execution and honest communication. Clients working with us at this stage get senior-level attention and a team whose success is directly tied to theirs.' },
  { q: 'Are you based in Japan?', a: 'Yes. Bybeit, Inc. is a Japanese corporation based in Tokyo.' },
]

export default function FAQSection() {
  const { t } = useLocale()
  const [open, setOpen] = useState<number | null>(null)

  return (
    <section className="faq-section" id="faq" style={{ background: 'var(--home-bg)' }}>
      <div className="container">
        <div className="section-header">
          <span className="section-jp">{t("FAQ")}</span>
          <h2>{t("Questions? Answers.")}</h2>
        </div>

        <div className="faq-list">
          {faqs.map((f, i) => (
            <div
              className={`faq-item${open === i ? ' faq-item--open' : ''}`}
              key={f.q}
            >
              <button
                className="faq-q"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                <span>{t(f.q)}</span>
                <CaretDown size={18} className="faq-chevron" weight="bold" />
              </button>
              <div className="faq-a">
                <div className="faq-a-inner">
                  {t(f.a).split('\n\n').map((para, i) => (
                    <p key={i}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
